<template>
  <div>
    <vue-element-loading is-full-screen :active="loading" spinner="bar-fade-scale" color="#152d51" />
  </div>
</template>

<script>
import VueElementLoading from "vue-element-loading";
export default {
  components: { VueElementLoading },
  data() {
    return {
      loading: true,
    };
  },
  mounted() {},
  methods: {},
  computed: {},
};
</script>

<style></style>
